<template>
  <div class="home-box">
    <div class="box">
      <div class="b-title"><span style="margin-left: 16px;">{{title}}</span></div>
      <div class="rowList">
        <div class="row">
          <div class="row-l">标题：</div>
          <div class="row-r">
            <el-input 
            maxlength="30"
            show-word-limit
            v-model="form.newsTitle"
            size="small" 
            placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="row-l">图片展示：</div>
          <div class="row-r">
            <el-radio v-model="form.imgShow" @change="aaa" :label="0">是</el-radio>
            <el-radio v-model="form.imgShow" :label="1">否</el-radio>
          </div>
        </div>
        <div class="row">
          <div class="row-l">图片：</div>
          <div class="row-r">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHead"
              :data="{ type: 261 }"
              :limit="1"
              :on-success="onSuccess2"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :before-upload="beforeUpload6"
              list-type="picture">
              <el-button v-if="!form.imgContent" size="small" type="primary">点击上传</el-button>
              <span v-if="form.imgContent" style="font-size:12px;color:red;">如需更换图片，请先删除现有图片！</span>
            </el-upload>
          </div>
        </div>
        <div class="row">
          <div class="row-l">人物名称：</div>
          <div class="row-r">
            <el-input v-model="form.name" size="small" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="row-l">内容编辑：</div>
          <div class="row-r" style="width: 81vw;">
            <!-- <el-input
              type="textarea"
              maxlength="2000"
              show-word-limit
              :autosize="{ minRows: 22}"
              placeholder="请输入内容"
              v-model="form.newsContent">
            </el-input> -->
            <div ref="editorElem"></div>
          <div style="text-align:end;"><span v-if="!textLock" style="font-size:14px;color:red;">最多输入字数2000!</span><span style="color:#909399;font-size:12px;margin-left:20px">{{textSize}}/2000</span></div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="btn1" @click="exit">返回</div>
        <div class="btn2" @click="createInfoXmDj">发布</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
import E from "wangeditor"
  export default {
    data() {
      return {
        editor: null,
        html:'',
        title: '新增内容',
        typeList: [
          {
            name:'党员大会',
            value:1
          },
          {
            name:'支部会议',
            value:2
          },
          {
            name:'党小组会',
            value:3
          },
          {
            name:'党课',
            value:4
          },
          {
            name:'民主生活会',
            value:5
          },
          {
            name:'报告工作',
            value:6
          },
          {
            name:'党员汇报',
            value:7
          },
          {
            name:'民主评议',
            value:8
          },
          {
            name:'每周一课',
            value:9
          },
          {
            name:'党建活动',
            value:10
          },
          {
            name:'工会活动',
            value:11
          },
          {
            name:'其他',
            value:12
          },
        ],
        form:{
          newsType:13,
          projectId:util.session.get('groupId'),
          newsTitle:'',
          newsContent:'',
          imgContent:'',
          personCount:'',
          imgShow:1,
          name:'',
        },
        uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
            //上传接口header
            accessToken: this.$store.state.token,
          },
        lock:true,
        fileList:[],
        textSize:'0',
        textLock:true
      }
    },
    mounted(){
      if(this.$route.query.type==2){
        this.title = '编辑内容'
        myHttp.getByIdNew({
          id:this.$route.query.id
        }).then(res=>{
          if(res.data.code==200){
            if(res.data.data.imgContent!=''){
              let imgS = res.data.data.imgContent.split(',')
              imgS.forEach(item=>{
              this.fileList.push({url:base.httpCtx+item})
            })
            }
            for(let key in this.form){
              this.form[key] = res.data.data[key]
            }
            this.createInfo()
          }
        })
      }else{
        this.createInfo()
      }
    },
    methods:{
      createInfo(){
        this.editor = new E(this.$refs.editorElem);//获取组件并构造编辑器
        this.editor.config.menuTooltipPosition = 'down'
        this.editor.config.menus = [
          'head',  // 标题
          'bold',  // 粗体
          'fontSize',  // 字号
          'fontName',  // 字体
          'lineHeight',
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'list',  // 列表
          'justify',  // 对齐方式
          'image',  // 插入图片
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.editor.config.lineHeights = ['1', '1.15', '1.6', '2', '2.5', '3']
        this.editor.config.onchange = (html,text) => {
          this.form.newsContent = html
          console.log(html)
          console.log(this.editor.txt.text())
          this.textSize = this.editor.txt.text().split('').length
          if(this.textSize>2000){
            this.textLock=false
          }else{
            this.textLock=true
          }
        }
        // this.editor.config.uploadImgServer = base.url + '/upload/uploadPhoto'
        // this.editor.config.uploadFileName = 'file'
        // this.editor.config.uploadImgParams = {
        //     type: 260
        // }
        // this.editor.config.uploadImgHeaders = {
        //     accessToken: this.$store.state.token,
        // }
        // this.editor.config.uploadImgHooks = {
        //   before: function(xhr, editor, files) {
        //   // 图片上传之前触发
        //   // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        //   // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        //   // return {
        //   // prevent: true,
        //   // msg: '放弃上传'
        //   // }
        //   // console.log("before:",xhr, editor, files)
        //   },
        //   success: function(xhr, editor, result) {
        //   // 图片上传并返回结果，图片插入成功之后触发
        //   // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        //   console.log("success:",xhr, editor,result)
        //   },
        //   fail: function(xhr, editor, result) {
        //   // 图片上传并返回结果，但图片插入错误时触发
        //   // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        //   console.log("fail:",xhr, editor,result)
        //   },
        //   error: function(xhr, editor) {
        //   // 图片上传出错时触发
        //   // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        //   console.log("error:",xhr, editor)
        //   },
          // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
          // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
          // customInsert: function(insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，参数editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          // console.log(insertImg, result,)
          // var url = base.httpCtx+ result.data.saveUrls;
          // insertImg(url);
          // result 必须是一个 JSON 格式字符串！！！否则报错
          // }
        // };
        this.editor.create();

        this.editor.txt.html('<p>' + this.form.newsContent + '</p>')
      },
      beforeUpload6(item,i){
        this.lock=false
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        else if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }else  if(item.name.split('.')[item.name.split('.').length-1]=='webp'){
          return true
        }else{
          this.lock=true
          this.$message({
            type:'error',
            message:'请上传正确的文件格式（png,jpg,jepg,jfif,webp）'
          })
          return false
        }
      },
      aaa(){
        myHttp.checkImgShowNum({
          projectId:util.session.get('groupId')
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            if(res.data.data.imgShow!=null){
              this.form.imgShow = 1
              this.$message({
                type:'error',
                message:'展示图片最多11张，若需更换请先把要替换的图片选择不展示！'
              })
            }
            if(this.form.imgContent==''){
                this.form.imgShow = 1
                this.$message({
                type:'error',
                message:'请上传图片！'
              })
              }
          }
        })
      },
      handleRemove(item,i){
        this.lock=true
        if(this.form.imgContent.split(',').length==2){
          let a = this.form.imgContent.split(',')
          a.splice(item.response?item.response.data.saveUrls:item.url.split(base.httpCtx)[1],1)
          this.form.imgContent = a.join('')
        }else if(this.form.imgContent.split(',').length==1){
          this.form.imgContent = ''
        }else{
          let a = this.form.imgContent.split(',')
          a.splice(item.response?item.response.data.saveUrls:item.url.split(base.httpCtx)[1],1)
          this.form.imgContent = a.join(',')
        }
      },
      handlePreview(){
        this.lock=false
      },
      exit(){
        this.$router.go(-1)
      },
      onSuccess2(item,i,l){
        if(this.form.imgContent==''){
          this.form.imgContent = this.form.imgContent+item.data.saveUrls
        }else{
          this.form.imgContent = this.form.imgContent+','+item.data.saveUrls
        }
        console.log(this.form.imgContent)
        this.lock=true
      },
      createInfoXmDj(){
        if(this.form.newsTitle==''){
          this.$message({
            type:'error',
            message:'请输入内容标题！'
          })
          return
        }
        if(this.form.name==''){
          this.$message({
            type:'error',
            message:'请输入人物名称！'
          })
          return
        }
        if(this.lock){
          let that = this
          if(this.$route.query.type==1){
            that.form.moduleType='redchina'
            that.form.createBy = util.session.get('user').id
            myHttp.createInfoXmDj(this.form).then(res=>{
              console.log(res)
              if(res.data.code==200){
                that.$message({
                  type:'success',
                  message:res.data.msg
                })
                that.exit()
              }else{
                that.$message({
                  type:'error',
                  message:res.data.msg
                })
              }
            })
          }else{
            that.form.updateBy = util.session.get('user').id
            that.form.id = that.$route.query.id
            that.form.moduleType='redchina'
            myHttp.updateInfoDjNew(this.form).then(res=>{
              console.log(res)
              if(res.data.code==200){
                that.$message({
                  type:'success',
                  message:res.data.msg
                })
                that.exit()
              }else{
                that.$message({
                  type:'error',
                  message:res.data.msg
                })
              }
            })
          }
        }else{
          this.$message({
            type:'warning',
            message:'图片正在上传'
          })
        }
      }
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    width: 100%;
    height: 100%;
    border-radius:6px;
    overflow: hidden;
    background-color: #fff;
  }
  .b-title{
    text-align: start;
    height: 5vh;
    line-height: 5vh;
    font-size: 16px;
    color: #999999;
    border-bottom:2px solid rgb(236,240,245);
  }
  .row{
    margin-top: 14px;
    text-align: start;
    display: flex;
    margin-left: 16px;
  }
  .row-l{
    height: 100%;
    width: 70px;
    text-align: end;
    font-size: 14px;
    color: #999999;
    line-height: 24px;
  }
  .bottom{
    width: 100%;
    display: flex;
    height: 5vh;
    align-items: center;
    justify-content: center;
    box-shadow: 0px -10px 21px 0px rgba(225, 225, 225, 0.3);
  }
  .btn1{
    font-size: 14px;
    padding: 0 10px;
    height: 3vh;
    color: rgb(102, 102, 102);
    border: 1px solid rgb(153,153,153);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }
  .btn2{
    font-size: 14px;
    margin-left: 20px;
    padding: 0 10px;
    height: 3vh;
    background-color: #4D6EB1;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }
  .btn1:hover,.btn2:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .rowList{
    height: 79vh;
    overflow: auto;
  }
</style>